import { render, staticRenderFns } from "./ShippingZones.vue?vue&type=template&id=81867488&"
import script from "./ShippingZones.vue?vue&type=script&lang=js&"
export * from "./ShippingZones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports